/**
 * Entrada da equipe T4i com a conta Microsoft: registro "Portal de Chamados"
 * no Entra da T4i (05/10/2026). Os dois valores não são segredo; a API confere
 * o id_token contra os mesmos (Equipe:TenantId e Equipe:ClientId).
 *
 * Sem o ClientId a entrada da equipe some da tela: nem o link no login, nem o
 * botão na página da equipe.
 */
export const entradaEquipe = {
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID?.trim() || "",
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID?.trim() || "",
  get configurada() {
    return Boolean(this.tenantId && this.clientId);
  },
};
